import React, { useContext } from "react";
import UserContext from "../../../contexts/UserContext";
import ModalContext from "../../../contexts/ModalContext";
import ClientForm from "./clientForm";
import ClientDetail from "./clientDetail";



const ClientContent = ()=>{
    const {modalSection} = useContext(ModalContext)


    if(modalSection.includes('Form')){
        return(
            <ClientForm/>
        )
    }else{
        return(
            <ClientDetail/>
        )
    }
}

export default ClientContent